export default "__VITE_ASSET__Dv_E62Mt__"